export type LeadDetailTab = 'overview' | 'activity' | 'tasks' | 'form';

/**
 * Whether the lead detail page's Form tab trigger (and content) should
 * render, and which tab is actually active. The trigger needs at least one
 * submission, whatever the lead's source: a submission from someone with an
 * open lead is appended to that lead even when it came from a phone call or
 * was entered by hand. A deep link to `?tab=form` on a lead that doesn't
 * qualify falls back to the default tab instead of leaving the page on a
 * trigger-less, contentless panel.
 *
 * `isError` also earns the trigger even with a zero count — a failed request
 * isn't "zero submissions," and hiding the tab on error would bury the
 * failure inside a hidden panel with no way to reach it (or retry) instead
 * of showing the tab's own error state.
 */
export function resolveLeadFormTab(params: {
  requestedTab: LeadDetailTab;
  formSubmissionCount: number;
  isError?: boolean;
}): { activeTab: LeadDetailTab; showFormTab: boolean } {
  const showFormTab = params.formSubmissionCount > 0 || Boolean(params.isError);
  const activeTab =
    params.requestedTab === 'form' && !showFormTab ? 'overview' : params.requestedTab;
  return { activeTab, showFormTab };
}
